export enum LinkUnderlineWidth {
  Thin = '1px',
  Default = '2px',
}
